import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "CampaignEditorRightColumn" }
const _hoisted_2 = { class: "CampaignEditorLeftColumn" }
const _hoisted_3 = { class: "CampaignEditorRightColumn" }
const _hoisted_4 = ["value", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LoadingWrapper, {
      classes: ['CampaignEditorRow'],
      isLoading: _ctx.isLoading
    }, {
      default: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "CampaignEditorLeftColumn" }, [
          _createElementVNode("label", { class: "CampaignEditorInputLabel DropdownLabel CampaignSettingsInputRequired" }, " Delivery mode ")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_MultiSelect, {
            ref: "deliveryModeDropdown",
            label: "Choose the delivery mode",
            placeholder: " ",
            class: "CampaignEditorDropdown",
            options: _ctx.options,
            onUpdated: _ctx.setDeliveryMode
          }, null, 8 /* PROPS */, ["options", "onUpdated"])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isLoading"]),
    _createVNode(_component_LoadingWrapper, {
      classes: ['CampaignEditorRow'],
      isLoading: _ctx.isLoading
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", {
            class: _normalizeClass([
				'CampaignEditorInputLabel',
				'DropdownLabel',
				'CampaignSettingsInputRequired',
				{ 'ContentInvalid': _ctx.isFieldValidatedAndMissing || _ctx.isFieldValidatedAndInvalid }
			])
          }, " Overperformance limit ", 2 /* CLASS */)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("input", {
            class: _normalizeClass([
					'CampaignEditorInputField',
					{ 'ContentInvalid': _ctx.isFieldValidatedAndMissing || _ctx.isFieldValidatedAndInvalid }
				]),
            type: "number",
            min: "100",
            max: "999",
            value: _ctx.overPerformanceLimit,
            onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setOverPerformanceLimitBasedOnEvent && _ctx.setOverPerformanceLimitBasedOnEvent(...args))),
            disabled: _ctx.isDeliveryModeEvenly
          }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_4),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "InputDetailsMessage" }, " Custom overperformance limit (100 - 999%) ", -1 /* CACHED */)),
          _createElementVNode("div", {
            class: _normalizeClass([
				'ValidationMessage',
				{ 'ContentInvalid': _ctx.isFieldValidatedAndMissing || _ctx.isFieldValidatedAndInvalid }
			])
          }, _toDisplayString(_ctx.validationMessage), 3 /* TEXT, CLASS */)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isLoading"])
  ], 64 /* STABLE_FRAGMENT */))
}